import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import { useCallback, useState, type FC } from 'react';
import { validateAndOpenUrl } from '@/app/shared/utils/helpers';
import DownArrow from '@/assets/images/down-arrow.svg';
import TruStageLogo from '@/assets/images/trustage-logo.jpg';
import UpArrow from '@/assets/images/up-arrow.svg';
import { useLazyFetchTruStageUrlQuery } from '../../uploadStips.services';

interface TrustageSectionProps {
  contactId: string;
}

const TrustageSection: FC<TrustageSectionProps> = ({ contactId }) => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const [isTruStageLoading, setIsTruStageLoading] = useState(false);

  const [fetchTruStageURL] = useLazyFetchTruStageUrlQuery();
  const toggleExpand = (): void => setExpanded((prev) => !prev);

  const handleTruStagelink = useCallback(async () => {
    setIsTruStageLoading(true);

    try {
      const result = await fetchTruStageURL(contactId);
      const url = result.data as string | undefined;

      if (!url) {
        throw new Error('No URL returned from TruStage service');
      }
      validateAndOpenUrl(url);
    } catch (error: any) {
      const err = error instanceof Error ? error : new Error(String(error));

      if (error?.name !== 'CanceledError') {
        console.error('TruStage API Error:', err);
      }
    } finally {
      setIsTruStageLoading(false);
    }
  }, [fetchTruStageURL, contactId]);

  return (
    <div className="document-form__card">
      <div
        className="document-form__card--header"
        onClick={toggleExpand}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span className="document-form__card--header-description">Protection for the Unexpected</span>
        </div>

        {expanded ? (
          <img
            src={UpArrow}
            alt="Collapse"
          />
        ) : (
          <img
            src={DownArrow}
            alt="Expand"
          />
        )}
      </div>
      {expanded && (
        <div className="document-form__card--body insurance-offer-header">
          <div className="insurance-offer__powered-by_trustage">
            <span className="insurance-offer__powered-by-text insurance-offer__content">Powered by</span>
            <img
              src={TruStageLogo}
              alt="TruStage Logo"
              className="insurance-offer__logo"
            />
          </div>
          <div
            className="insurance-offer__content"
            style={{ display: 'flex', alignItems: 'flex-start' }}
          >
            <div className="insurance-offer__title">Be ready for what's next</div>

            <label className="insurance-offer__optin-container">
              <span className="insurance-offer__subtitle">
                As a customer of Hello Refi, you have access to Disability and Job Loss coverage through TruStage .&nbsp;
              </span>
            </label>

            {isTruStageLoading ? (
              <Link
                component="button"
                onClick={handleTruStagelink}
                disabled
                sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 ,color:'rgb(0, 0, 238)',marginTop:1}}
              >
                <CircularProgress size={14} />
                Loading...
              </Link>
            ) : (
              <Link
                component="button"
                sx={{color:'rgb(0, 0, 238)',marginTop:1,fontSize:'14px'}}
                onClick={handleTruStagelink}
              >
                Learn more
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrustageSection;
